import { render } from "./BatchImportModal.vue?vue&type=template&id=3a6c0ea6&scoped=true"
import script from "./BatchImportModal.vue?vue&type=script&lang=js"
export * from "./BatchImportModal.vue?vue&type=script&lang=js"

import "./BatchImportModal.vue?vue&type=style&index=0&id=3a6c0ea6&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6c0ea6"]])

export default __exports__